import React from 'react'
import { CardText as ReactstrapCardText, CardTextProps } from 'reactstrap'

export const CardText: React.FC<CardTextProps> = props => {
  return <ReactstrapCardText {...props} />
}
